// File: src/components/Modals/UserDetailModal.js
import React, { useState } from "react";
import { Modal, Button, message } from "antd";
import styles from "./UserDetailModal.module.css";
import UserGalleryModal from "./UserGalleryModal";
import { EditOutlined } from "@ant-design/icons";
import { useUnit } from "effector-react";
import { changeChosenUserEv } from "../../models/userListModel";
import { formatDOB } from "../../utils/dateUtils";

const UserDetailModal = ({ visible, onClose, user, setIsEditModalOpen }) => {
  const [galleryVisible, setGalleryVisible] = useState(false);

  if (!user) return null;

  return (
    <>
      <Modal
        title={
          <div className={styles.user_modal_title}>
            Информация о пользователе
          </div>
        }
        open={visible}
        onCancel={onClose}
        footer={null}
      >
        <div className={styles.user_modal_top}>
          <img
            src={user.presigned_url || "/default_student_image.png"}
            alt="Student"
            style={{
              width: 120,
              height: 120,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <div className={styles.user_modal_info_block}>
            <div>
              <b>Имя:</b> {user.user_name}
            </div>
            <div>
              <b>Фамилия:</b> {user.user_surname}
            </div>
            {/* <div>
              <b>Класс:</b> {user.grade_number}
              {user.grade_letter}
            </div> */}
            <div>
              <b>Дата рождения:</b> {formatDOB(user.date_of_birth)}
            </div>
            <div>
              <b>Пол:</b> {user.user_gender === "Male" ? "М" : "Ж"}
            </div>
          </div>
        </div>

        <div className={styles.user_modal_buttons_wrapper}>
          <Button
            // className={styles.user_modal_button}
            onClick={() => setGalleryVisible(true)}
          >
            Просмотреть все
          </Button>
          <Button
            icon={<EditOutlined />}
            onClick={() => {
              changeChosenUserEv(user); // Save user to store
              setIsEditModalOpen(true); // Show the edit modal
            }}
          >
            Редактировать
          </Button>

          <Button onClick={onClose}>Закрыть</Button>
        </div>
      </Modal>

      <UserGalleryModal
        visible={galleryVisible}
        onClose={() => setGalleryVisible(false)}
        userId={user.user_id || user.partition_key}
        placeId={user.place_id || user.sort_key}
      />
    </>
  );
};

export default UserDetailModal;
